import React from 'react';
import { InMailDetailsOutput } from 'graphql/generated/hasura';
import Avatar from 'components/avatarComponent';
import { Link } from 'react-router-dom';
import { MY_PATIENTS, PROVIDERS } from 'utilities/routes';
import { useAuth } from 'auth/context/AuthContext';
import { Roles } from '../../../firebase/interfaces';
import { useGetSignedUrlFromStorage } from 'hooks/useGetSignedUrlFromStorage';
import { useIsMobile } from 'hooks/useIsMobile';

const ConversationHeader: React.FC<{
  conversation: InMailDetailsOutput | undefined;
}> = ({ conversation }) => {
  const isMobile = useIsMobile();
  const size = isMobile ? 'xs' : 'sm_s';
  const { user } = useAuth();
  const signedPatientProfileUrl = useGetSignedUrlFromStorage(
    conversation?.patient?.profilePictureId ?? '',
    conversation?.patient?.codexId ?? '',
  );
  const signedProviderProfileUrl = useGetSignedUrlFromStorage(
    conversation?.provider?.profilePictureId ?? '',
    conversation?.provider?.codexId ?? '',
  );

  if (user?.role === Roles.PROVIDER) {
    const avatar = conversation?.patient?.profilePictureId
      ? signedPatientProfileUrl
      : undefined;
    return (
      <>
        <Avatar size={size} imageUrl={avatar} key={avatar} />
        <Link
          className="ml-2 text-clc-blue underline text-h3 font-semibold"
          to={`${MY_PATIENTS}/${conversation?.patient?.codexId}`}
          target="_blank"
        >
          {conversation?.patient?.firstName} {conversation?.patient?.lastName}
        </Link>
      </>
    );
  }

  if (user?.role === Roles.PATIENT) {
    const avatar = conversation?.provider?.profilePictureId
      ? signedProviderProfileUrl
      : undefined;
    return (
      <>
        <Avatar size={size} imageUrl={avatar} key={avatar} />
        <Link
          className="ml-2 text-clc-blue underline text-h5 desktop:text-h3 font-semibold"
          to={`${PROVIDERS}/${conversation?.provider?.codexId}`}
          target="_blank"
        >
          {conversation?.provider?.firstName} {conversation?.provider?.lastName}
        </Link>
      </>
    );
  }

  return null;
};

export default ConversationHeader;
